import React from "react";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import { getApiUrl } from "utils";

const ActiveUserInfo = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const onSubmit = () => {
    if (!activeUserDetail) {
      return toast.error(
        "User details not found or Your KYC is incomplete. Thank You!"
      );
    }
    // if (activeUserDetail.incomeproof.length === 0) {
    //   return toast.error(
    //     "You have not selected any segment in Ekyc. so you can't add/update income proof."
    //   );
    // }
    setStep("CheckPrevRequest");
  };
  return (
    <div>
      <Title title="Income Details" />
      <div className="col-md-9 mt-3">
        <div className="ml-2">
          {activeUserDetail && (
            <div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">Full Name</h6>
                  <div className="col-sm">{activeUserDetail.full_name}</div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">Mobile Number</h6>
                  <div className="col-sm">
                    {activeUserDetail.phone?.slice(2)}
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">Email Address</h6>
                  <div className="col-sm">{activeUserDetail.email}</div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">PAN Number</h6>
                  <div className="col-sm">
                    {activeUserDetail.poi?.[0]?.pan_number}
                  </div>
                </div>
              </div>
              {activeUserDetail.incomeproof?.length > 0 && (
                <>
                  <div className="row mt-2">
                    <div className="row">
                      <h6 className="col-sm">Annual Income</h6>
                      <div className="col-sm">
                        {activeUserDetail.annual_income_detail}
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="row">
                      <h6 className="col-sm">Income proof type</h6>
                      <div className="col-sm">
                        {activeUserDetail.incomeproof[0]?.icp_type}
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="row">
                      <h6 className="col-sm">Income proof file</h6>
                      {activeUserDetail.incomeproof[0]?.icp && (
                        <a
                          className="col-sm"
                          href={
                            getApiUrl() + activeUserDetail.incomeproof[0].icp
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download here
                        </a>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          <div className="d-flex mt-4">
            <div className="ml-2">
              <Button
                type="button"
                title="Back"
                handleClick={() => setStep("ValidatePan")}
                loading={isLoading}
              />
            </div>
            <div className="mx-2">
              <Button
                title="Next"
                handleClick={() => onSubmit()}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveUserInfo;
